import BackButton from 'Components/BackButton'
import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import { WithLoader } from 'Components/WithLoader'
import { ServiceProviderForm } from 'Services/ServiceProviderManagement/Features/ServiceProvider/Components/ServiceProviderForm'
import { SELECTED_SERVICE_PROVIDER_PARAMETER_KEY } from 'Services/ServiceProviderManagement/Features/ServiceProvider/Hooks/useServiceProvidersWithParams'
import { useGetSingleServiceProviderQuery } from 'Services/ServiceProviderManagement/Features/ServiceProvider/serviceProviderApi'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { SERVICE_PROVIDER_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { Box, Grid } from '@mui/material'
import { useParams } from 'react-router-dom'
import { t } from 'ttag'

export default function ServiceProviderEditPage() {
  const baseUrl = `${SERVICE_PROVIDER_MANAGEMENT_ROOT_URL}/service-providers`
  const { id, pta } = useParams()
  const previousLocation = usePreviousLocation(
    `${baseUrl}?${SELECTED_SERVICE_PROVIDER_PARAMETER_KEY}=${id}`
  )

  const { data: singleServiceProvider, isLoading } = useGetSingleServiceProviderQuery(
    { serviceProviderId: id ?? '', pta: pta ?? '' },
    { skip: !id || !pta }
  )

  const breadcrumbs = [
    {
      title: t`Home`,
      link: SERVICE_PROVIDER_MANAGEMENT_ROOT_URL
    },
    {
      title: t`Service providers`,
      link: baseUrl
    },
    {
      title: singleServiceProvider ? singleServiceProvider.name : ''
    }
  ]

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} mb={4}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
          <BackButton label={t`Back`} link={previousLocation} />
          <PageTitle>{t`Edit service provider`}</PageTitle>
        </Grid>
      </Grid>
      <WithLoader loading={isLoading}>
        <ServiceProviderForm
          serviceProvider={singleServiceProvider}
          successBaseUrl={previousLocation}
        />
      </WithLoader>
    </Box>
  )
}
